import styles from "./MobilePage.module.scss";

interface IMobilePageBaseProps {
    children: any;
}

export function MobilePageBase(props: IMobilePageBaseProps) {
    return <div className={styles.host}>{props.children}</div>
}